// @flow
import { t } from '@lingui/macro';

const parseApiErrors = (response: any = {}) => {
  const errors = [];
  let json;

  if (response.status && response.status === 429) {
    errors.push(t`Please slow down and try again in a few minutes`);
  } else if ([403, 405, 422, 500].includes(response.status)) {
    errors.push(
      t`We were unable to process your request. Please try again shortly or contact Customer Support.`
    );
  } else {
    json =
      response.response ||
      (response.responseText && JSON.parse(response.responseText)) ||
      response.data;
  }
  if (json) {
    let { error_description: errorDescription, non_field_errors: nonFieldErrors, error } = json;

    const { detail, error_type: errorType } = json;

    if (detail) {
      errors.push(detail);
    }

    if (error && typeof error === 'object' && errorType !== 'field_validation') {
      if (error.error_description) {
        errorDescription = error.error_description;
      } else if (error.error_status) {
        errorDescription = error.error_status;
      }
      if (error.non_field_errors) nonFieldErrors = error.non_field_errors;
      if (!errorDescription && !nonFieldErrors) error = JSON.stringify(error);
    }

    if (errorDescription) errors.push(errorDescription);
    if (typeof error === 'string') errors.push(error);

    if (Array.isArray(nonFieldErrors)) {
      errors.push(...nonFieldErrors);
    } else if (nonFieldErrors) {
      errors.push(nonFieldErrors);
    }
    if (!errors.length && typeof json === 'object') {
      Object.keys(json).forEach((errorKey: string) => {
        // $FlowFixMe
        errors.push(`${json[errorKey]}`);
      });
    }
  }

  return errors;
};

export default parseApiErrors;



// WEBPACK FOOTER //
// ../utilities/parseApiErrors.js